import React from 'react';

function AboutPage() {
    return <div>About Us Page</div>;
}

export default AboutPage;
